module.exports = __webpack_public_path__ + "static/media/ServiceHistory.5f62c638.svg";